import React, { useState } from "react"
import {
  ContactContainer,
  NewsletterContainer,
  Wrapper,
  Copyright,
} from "./styles"
import { FaMapMarkerAlt, FaEnvelope } from "react-icons/fa"
import { Row, Col } from "react-bootstrap"
import addToMailchimp from "gatsby-plugin-mailchimp"
import NewsletterWave from "../../img/newsletter_wave.svg"
import { renderHTML } from "../../agility/utils"

const GlobalFooter = ({ footerData }) => {
  // setup email state
  const [email, setEmail] = useState("")

  // set up message
  const [message, setMessage] = useState("")

  // handle submit function
  const handleSubmit = async e => {
    e.preventDefault()
    const result = await addToMailchimp(email)

    setMessage(result.msg)
  }

  // handle change function
  const handleChange = e => {
    setEmail(e.target.value)
  }
  return (
    <footer id="contact">
      <ContactContainer>
        <Wrapper>
          <h3>{footerData.contactTitle}</h3>
          <Row>
            <Col lg={6} className="contact">
              <FaMapMarkerAlt />
              <p>
                <a
                  href={footerData.addressLink.href}
                  title={footerData.addressLink.text}
                  target={footerData.addressLink.target}
                >
                  {footerData.address}
                </a>
              </p>
            </Col>
            <Col lg={6} className="email">
              <FaEnvelope />
              <a href={`mailto:${footerData.email}`}>{footerData.email}</a>
            </Col>
          </Row>
        </Wrapper>
      </ContactContainer>
      <NewsletterContainer img={NewsletterWave}>
        <Wrapper>
          <h3>{footerData.newsletterTitle}</h3>
          <form onSubmit={handleSubmit}>
            <label htmlFor="email" className="visuallyhidden">
              Newsletter
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={handleChange}
              placeholder={footerData.inputText}
            />
            <button type="submit">{footerData.buttonText}</button>
          </form>
          <p
            className="form-message"
            dangerouslySetInnerHTML={renderHTML(message)}
          />
        </Wrapper>
      </NewsletterContainer>
      <Copyright>
        <p>
          Website by{" "}
          <a
            href="https://www.webdisco.digital"
            target="_blank"
            rel="noreferrer noopener"
            title="Toronto Web Design"
          >
            Web Disco Digital
          </a>
        </p>
      </Copyright>
    </footer>
  )
}

export default GlobalFooter
